import { sendLogInCred, getSubUser, getLoginRoleDetails, ssoAuth, revokeToken, verifyOTPV2 } from "shared/api";

import { AUTH_SUCCESS, AUTH_FAIL, AUTH_START, SIGN_OUT } from "./authTypes";
import { ROLE } from "redux/actions/role/roleTypes";
import Axios from "axios";
import { decodeJwtPayload, decryptShaHash, toastError } from "shared/utils";

export const signIn = (data, isSSO = false) => async (dispatch) => {
  dispatch({
    type: AUTH_START,
  });

  if(data.ipAddress == null || data.client_ip == null){
    await Axios.get('https://api.ipify.org?format=json').then((res) => {
      data.client_ip = res.data.ip;
      if (!isSSO) {
        data.ipAddress = res.data.ip;
      }
    })
  }
  
  try {
    let res = {};
    if (isSSO) {
      res = await ssoAuth(data);
    } else {
      res = await verifyOTPV2(data);
    }

    if ((isSSO && res?.data?.is_panel_user) || !isSSO) {
      const userData = await getSubUser(res.data.token);
      let user = userData.data.data.subuser;
      let roles = userData.data.data.role;
      let config = userData.data.data.config

      user["token"] = res.data.token;
      if(roles && config){
        decryptShaHash(roles["id"], config).then((decrypted) => {
          const objRes = JSON.parse(decrypted);
          let tokenData = decodeJwtPayload(user["token"]);
          if(tokenData.jti != objRes.jti){
            localStorage.clear();
            dispatch({
              type: SIGN_OUT,
            });
          }else{
            roles["id"] = parseInt(objRes.role_id);
            localStorage.setItem("role", JSON.stringify(roles));
            dispatch({
              type: ROLE,
              payload: roles,
            });
          }
        }).catch((e) => {
          localStorage.clear();
          dispatch({
            type: SIGN_OUT,
          });
        });
      }
      
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("role", JSON.stringify(roles));
      
      dispatch({
        type: ROLE,
        payload: roles,
      });

      dispatch({
        type: AUTH_SUCCESS,
        payload: { user: user },
      });
    } else {
      let user = {}
      user["token"] = res.data.token;
      dispatch({
        type: AUTH_SUCCESS,
        payload: { user: user },
      });
    }


    return res.data

  } catch (err) {
    toastError(err?.message || "Something went wrong");
    dispatch({
      type: AUTH_FAIL,
    });
    return false;
  }
};

export const signOut = (_) => async (dispatch) => {
  try {
    // localStorage.removeItem("user");
    // localStorage.removeItem("role");
    let userDetails = JSON.parse(localStorage.getItem('user'));
    if(userDetails?.token){
      revokeToken();
    }
    localStorage.clear();
    dispatch({
      type: SIGN_OUT,
    });
  } catch (error) {
    console.error(error);
  }
};
